export enum QwRateCodeKeys {
  RA1 = 'RA1',
  RB1 = 'RB1',
  RH1 = 'RH1',
  RA3 = 'RA3',
  RB3 = 'RB3',
  RH3 = 'RH3',
  RA4 = 'RA4',
  RB4 = 'RB4',
  RH4 = 'RH4',
}

interface QwRateInfo {
  value: boolean;
  visible: boolean;
  activateCombo: Array<string[]>;
  directCheckout: boolean;
}

const QW_RATE_INFO_DEFAULT: QwRateInfo = {
  value: false,
  visible: true,
  activateCombo: [],
  directCheckout: true,
};

export const QW_RATE_CODES: Record<string, QwRateInfo> = {
  [QwRateCodeKeys.RA1]: {
    value: false,
    visible: true,
    activateCombo: [],
    directCheckout: true,
  },
  [QwRateCodeKeys.RA3]: {
    value: false,
    visible: true,
    activateCombo: [],
    directCheckout: true,
  },
  [QwRateCodeKeys.RA4]: {
    value: false,
    visible: true,
    activateCombo: [],
    directCheckout: true,
  },
  [QwRateCodeKeys.RB1]: {
    value: false,
    visible: false,
    activateCombo: [
      [QwRateCodeKeys.RA1, QwRateCodeKeys.RB3],
      [QwRateCodeKeys.RA1, QwRateCodeKeys.RB4],
    ],
    directCheckout: false,
  },
  [QwRateCodeKeys.RB3]: {
    value: false,
    visible: true,
    activateCombo: [],
    directCheckout: true,
  },
  [QwRateCodeKeys.RB4]: {
    value: false,
    visible: true,
    activateCombo: [],
    directCheckout: true,
  },
  [QwRateCodeKeys.RH1]: {
    value: false,
    visible: false,
    activateCombo: [
      [QwRateCodeKeys.RA1, QwRateCodeKeys.RH3],
      [QwRateCodeKeys.RA1, QwRateCodeKeys.RH4],
    ],
    directCheckout: true,
  },
  [QwRateCodeKeys.RH3]: {
    value: false,
    visible: true,
    activateCombo: [],
    directCheckout: true,
  },
  [QwRateCodeKeys.RH4]: {
    value: false,
    visible: true,
    activateCombo: [],
    directCheckout: true,
  },
};

export function getQwRateCodeInfo(code: string, rateCodes = QW_RATE_CODES) {
  return rateCodes[code] || QW_RATE_INFO_DEFAULT;
}

export const cloneDeep = (value: any) => JSON.parse(JSON.stringify(value));
